import { Buildings } from "@phosphor-icons/react";
import {
  Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { useEmpresa } from "@/contexts/EmpresaContext";

// Radix Select no admite "" como valor de item; se usa este centinela para "todas".
const TODAS = "__todas__";

/**
 * Selector de "empresa activa" del super_admin, en la cabecera del Sidebar. Al cambiar,
 * toda la interfaz se recarga acotada a esa empresa (ver Layout: key en el <Outlet/>).
 */
export default function EmpresaSwitcher() {
  const { habilitado, empresas, empresaActivaId, setEmpresaActivaId } = useEmpresa();
  if (!habilitado) return null;

  return (
    <div className="px-4 py-3 border-b border-slate-200 bg-white">
      <label className="text-[10px] tracking-[0.14em] uppercase text-slate-400 font-bold flex items-center gap-1.5 mb-1.5">
        <Buildings size={12} weight="bold" />
        Empresa
      </label>
      <Select
        value={empresaActivaId || TODAS}
        onValueChange={(v) => setEmpresaActivaId(v === TODAS ? "" : v)}
      >
        <SelectTrigger
          className="w-full h-9 text-sm bg-slate-50 border-slate-200"
          data-testid="empresa-switcher"
        >
          <SelectValue placeholder="Todas las empresas" />
        </SelectTrigger>
        <SelectContent className="max-h-72">
          <SelectItem value={TODAS} data-testid="empresa-switcher-todas">
            Todas las empresas
          </SelectItem>
          {empresas.length > 0 && (
            <SelectGroup>
              <SelectLabel className="text-[10px] uppercase tracking-wider text-slate-400">
                Ver una empresa
              </SelectLabel>
              {empresas.map((e) => (
                <SelectItem key={e.id} value={e.id}>
                  {e.razon_social}
                </SelectItem>
              ))}
            </SelectGroup>
          )}
        </SelectContent>
      </Select>
    </div>
  );
}
